import merge from 'lodash/merge'
import defaultTypography from '../typography'

export const FONTS = {
  REGULAR: '"GT America Regular", Helvetica, Arial, sans-serif',
  BOLD: '"Pensum Pro Bold", Helvetica, Arial, sans-serif',
  SEMI_BOLD: '"Pensum Pro Bold", Helvetica, Arial, sans-serif',
  TITLE: '"Pensum Pro Bold", Helvetica, Arial, sans-serif',
}

export const COLORS = {
  white: '#FFFFFF',
  black: '#000000',
  blackAlpha28: '#C0C0C0',
  blackAlpha76: '#464646',
  black30: '#24082D',
  greyMedium: '#707070',
  greyMediumAlpha60: '#ADADAD',
  greyLight: '#EBEBEB',
  info: '#029DD2',
  success: '#38B25D',
  error: '#C6423F',
  warning: '#FFAC5A',
  bgColor: '#F6F6F6',
  flordDarker: '#2C3B47',
  ultraLight4: '#F7F7F7',
  almostBlack: '#212427',
}
export const typography = merge({}, defaultTypography, {
  heading: {
    large: {
      fontFamily: FONTS.TITLE,
      color: COLORS.black,
    },
    small: {
      fontFamily: FONTS.TITLE,
      color: COLORS.black,
    },
    subheading: {
      fontFamily: FONTS.TITLE,
      color: COLORS.black,
    },
  },
  copy: {
    title: {
      color: COLORS.black,
      fontFamily: FONTS.BOLD,
    },
    body: {
      color: COLORS.black,
      fontFamily: FONTS.REGULAR,
    },
    bodyBold: {
      color: COLORS.black,
      fontFamily: FONTS.BOLD,
    },
    bodyFaint: {
      color: COLORS.greyMedium,
      fontFamily: FONTS.REGULAR,
    },
    tiny: {
      color: COLORS.black,
      fontFamily: FONTS.REGULAR,
    },
    tinyFaint: {
      color: COLORS.greyMedium,
      fontFamily: FONTS.REGULAR,
    },
    tinyBold: {
      color: COLORS.black,
      fontFamily: FONTS.BOLD,
    },
  },
  label: {
    color: COLORS.greyMedium,
    fontFamily: FONTS.SEMI_BOLD,
  },
  optional: {
    color: COLORS.greyMedium,
    fontFamily: FONTS.REGULAR,
  },
})
